import type { ButtonHTMLAttributes, ReactNode } from "react";

export type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: "normal" | "small";
  /** Shows a spinner and disables the button. */
  busy?: boolean;
  children: ReactNode;
}

export function Button({
  variant = "primary",
  size = "normal",
  busy = false,
  className,
  children,
  disabled,
  type = "button",
  ...rest
}: ButtonProps) {
  const classes = [
    "hx-button",
    `hx-button--${variant}`,
    size === "small" && "hx-button--small",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || busy}
      aria-busy={busy || undefined}
      {...rest}
    >
      {busy && <span className="hx-spinner" aria-hidden="true" />}
      {children}
    </button>
  );
}
